import { ApiEndpoints } from "../api/endpoints";
import ApiService from "./apiService";
class AuthorizeService {
    constructor() {
        this.exchangeAccessCodeForToken = async (accessCodeRequest) => {
            try {
                const result = await ApiService.post(ApiEndpoints.authorize.exchangeAccessCode, accessCodeRequest);
                return result.data.result;
            }
            catch {
                return null;
            }
        };
        this.refreshToken = async (refreshToken) => {
            try {
                const result = await ApiService.post(ApiEndpoints.authorize.refreshToken, refreshToken);
                return result.data.result;
            }
            catch {
                return null;
            }
        };
    }
}
export default new AuthorizeService();
